<template>
  <div>
    <navbar>
    </navbar>
    <!--END Navbar-->

    <buttons
        :orderPaymentPaidDate="orderPaymentPaidDate"
        :order="order"></buttons>

    <b-row>
      <b-col>
        <b-card>
          <b-tabs content-class="mt-3">
            <b-tab title="Information" active>

              <div class="sticky-top">
                <b-alert show v-if="order.order_status === 'pending'" variant="warning">
                  <p class="mb-0">{{ $t('order_pending_text') }}</p>
                </b-alert>
                <b-alert show v-if="order.order_status === 'return_request'" variant="warning">
                  <p class="mb-0">{{ $t('order_return_text') }}</p>
                </b-alert>
                <template>
                  <b-alert show v-if="order.order_send_email_type_status === 'payingMoney'"
                           variant="success">
                    <p class="mb-0">{{ $t('order_paying_money_returned_success_text') }}</p>
                  </b-alert>
                  <b-alert show v-else-if="order.order_status === 'cancel'" variant="warning">
                    <p class="mb-0">{{ $t('order_paying_money_text') }}</p>
                  </b-alert>

                </template>
                <b-alert show v-if="order.order_status === 'reviewed'" variant="primary">
                  <p class="mb-0">Die Bestellung wurde durch den Lord Of Hanf überprüft</p>
                </b-alert>
                <b-alert show v-if="order.order_status === 'posted'" variant="success">
                  <p class="mb-0">{{ $t('order_posted_text') }}</p>
                </b-alert>
                <b-alert show v-if="order.order_status === 'return_accept'" variant="success">
                  <p class="mb-0">{{ $t('order_return_success_text') }}</p>
                </b-alert>
              </div>


              <div class="row">

                <div class="col-12">

                  <div v-if="(order.order_notes != null && order.order_notes.length > 0) || order.order_cancel_reason != null || order.order_cancel_description != null"
                       class="p-4" style="border: 3px solid red">
                    <h3 class="mt-4">Bestellnotiz</h3>
                    <div v-html="order.order_notes"></div>

                    <h3 class="mt-4">Artikel stornieren</h3>
                    <span class="font-weight-bold">Warum möchten Sie den Artikel zurückgeben?</span>
                    <p>{{ order.order_cancel_reason }}</p>

                    <template v-if="order.order_cancel_description !== null">
                      <span class="font-weight-bold">Anmerkungen:</span>
                      <div v-html="order.order_cancel_description"></div>
                    </template>
                  </div>

                </div>

                <div class="col-12 col-md-6">
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ $t('dateTitle') }}
                      <span>{{ orderDate }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ $t('order_user') }}
                      <span>{{ orderMoreData.user }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ $t('order_fname') }}
                      <span>{{ order.order_fname }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ $t('order_lname') }}
                      <span>{{ order.order_lname }}</span>
                    </li>
                    <template v-if="role === 'admin'">
                      <li class="list-group-item d-flex justify-content-between align-items-center">
                        {{ $t('comment_email') }}
                        <span>{{ order.order_email }}</span>
                      </li>
                      <li class="list-group-item d-flex justify-content-between align-items-center">
                        {{ $t('order_phone') }}
                        <span>
                                                <a
                                                    class="font-weight-bold"
                                                    style="color: #0a6ebd;letter-spacing: 2px"
                                                    :href="'tel:'+order.order_phone">{{ order.order_phone }}</a>
                                            </span>
                      </li>
                    </template>


                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ $t('order_country') }}
                      <span>{{ orderMoreData.country }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ $t('order_company_name') }}
                      <span>{{ order.order_company_name }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ $t('order_street') }}
                      <span>{{ order.order_address_street }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ $t('order_aparteman') }}
                      <span>{{ order.order_address_aparteman }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ $t('order_post_code') }}
                      <span>{{ order.order_postcode }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ $t('order_city') }}
                      <span>{{ order.order_city }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ $t('order_transport') }}
                      <span>{{ orderMoreData.transport }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ $t('order_number') }}
                      <span>{{ order.order_tracking_number }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ $t('order_price') }}
                      <span class="font-weight-bold">{{ order.order_price | numFormat('0.00') }} €</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ $t('order_payment_method') }}
                      <span>{{ orderMoreData.payment_type }}</span>
                    </li>
                  </ul>
                </div>
                <div class="col-12 col-md-6">
                  <h3>Address</h3>
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ orderDeliveryAddress.gender }} {{ orderDeliveryAddress.first_name }}
                      {{ orderDeliveryAddress.last_name }}
                      <template v-if="orderDeliveryAddress.company_name !== null">
                        "{{ orderDeliveryAddress.company_name }}"
                      </template>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ orderDeliveryAddress.address }} {{ orderDeliveryAddress.address_more }}
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ orderDeliveryAddress.post_code }} {{ orderDeliveryAddress.town }}
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      {{ orderDeliveryAddress.country }}
                    </li>
                  </ul>

                  <h3 class="mt-5">Delivery Address
                    <b-button variant="danger" @click="print">Print</b-button>
                  </h3>
                  <div v-if="orderAddress !== null" id="printMe">
                    <p v-if="orderAddress.company_name !== null" class="mb-0">
                      Firma: {{orderAddress.company_name}}
                    </p>
                    <p class="mb-0">{{ orderAddress.gender }}
                      {{ orderAddress.first_name }}
                      {{ orderAddress.last_name }}</p>
                    <p class="mb-0">{{ orderAddress.address }}
                      {{ orderAddress.address_more }}</p>
                    <p class="mb-0">{{ orderAddress.post_code }}
                      {{ orderAddress.town }}</p>
                    <p class="mb-0">{{ orderAddress.country }}</p>
                  </div>

                </div>


              </div>
            </b-tab>

            <b-tab>
              <template #title>
                <span class="mr-2">Orders</span>
                <span>
                                    <b-badge variant="danger">{{ products.length }}</b-badge>
                                </span>
              </template>

              <h3 class="font-weight-bold">Gifts</h3>
              <b-row>
                <b-col v-for="(gift,index) in orderGifts" :key="index" cols="12" md="3">
                  <gift :gift="gift"></gift>
                </b-col>
              </b-row>
              <br>
              <h3 class="font-weight-bold">Orders</h3>
              <order-products :products="products"></order-products>
              <br>

            </b-tab>
            <b-tab title="Post & DPD">
              <post-and-dpd
                  :order="order"
                  :orderLogs="orderLogs"></post-and-dpd>
            </b-tab>
            <b-tab>
              <template #title>
                <span class="mr-2">History</span>
                <span>
                                    <b-badge variant="danger">{{ userOrders.length }}</b-badge>
                                </span>
              </template>
              <history :userOrders="userOrders"></history>
            </b-tab>
            <b-tab title="Gifts" v-if="orderGifts.length > 0">
              <b-row>
                <b-col v-for="(gift,index) in orderGifts" :key="index" cols="12" md="3">
                  <gift :gift="gift"></gift>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'
import Notification from '../../Services/Notification/Nottification'
import OrderProducts from "./components/orderProducts";
import PostAndDpd from "./components/postAndDpd";
import {EventBus} from "../../Services/Eventbus/event-bus";
import Buttons from "./components/Buttons";
import History from "./components/history";
import Gift from "./components/Gift";

export default {
  name: "Details",
  components: {Gift, History, Buttons, PostAndDpd, OrderProducts, Navbar},
  data() {
    return {
      role: null,
      order: {},
      orderDate: null,
      orderPaymentPaidDate: null,
      orderLogs: [],
      orderGifts: [],
      orderMoreData: {},
      orderAddress: {},
      orderDeliveryAddress: {},
      products: [],
      userOrders: [],
      formUpdateStatus: {
        type: null,
        status: null
      }
    }
  },
  methods: {
    print() {
      this.$htmlToPaper('printMe');
    },
    updateStatus(myType, myValue) {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'order/update/' + this.$route.params.orderid, {
        type: myType,
        status: myValue,
      })
          .then(response => {
            if (response.data.status_code === Http.ok()) {
              this.$Progress.finish();
              Notification.success(response.data.message);
            } else {
              Notification.error(response.data.message);
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    getOrderDetails() {
      if (this.$route.params.orderid && this.$route.params.orderid > 0) {
        this.$Progress.start();
        Http.get(Http.apiurlV2() + 'order/show/' + this.$route.params.orderid)
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.order = response.data.data.order;
                this.orderDate = response.data.data.orderDate;
                this.orderPaymentPaidDate = response.data.data.orderPaymentPaidDate;
                this.orderLogs = response.data.data.orderLogs;
                this.orderMoreData = response.data.data.order_moredata;
                this.orderAddress = response.data.data.order_address;
                this.orderDeliveryAddress = response.data.data.order_delivery_address;
                this.products = response.data.data.products;
                this.userOrders = response.data.data.user_orders;
                this.orderGifts = response.data.data.gifts;
              } else {
                Notification.error(response.data.message)
              }
            })
            .catch(error => {
              this.$Progress.finish();
              this.$notify({
                type: 'danger',
                title: this.$t('invalid-request')
              })
            })
      }
    }
  },
  created() {
    window.scrollTo(0, 0);
    this.getOrderDetails();
    this.role = localStorage.getItem('role');
  },
  mounted() {
    let myThis = this;
    EventBus.$on('updateLog', function (payload) {
      if (payload === 'yes') {
        myThis.getOrderDetails()
      }
    });
  }
}
</script>

<style scoped>

</style>